import styled from '@emotion/styled';

export const SlaFieldContainer = styled.div`
  display: flex;
`;
